import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-174f95ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-7 gap-y-4 pt-2 my-justify-self-center bg-white dark:bg-dark-500" }
const _hoisted_2 = {
  key: 0,
  class: "text-accept dark:text-teal-700"
}
const _hoisted_3 = {
  key: 1,
  class: "text-reject dark:text-red-800"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  class: "font-bold mx-1 text-gray-800 dark:text-dark-text",
  style: {"font-size":"0.5vw"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.judgeStepList, (step, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `circle-${step}`,
        class: _normalizeClass(["relative material-icons text-3xl flex justify-center text-gray-800 dark:text-dark-text", {
        'right-border': idx !== _ctx.len - 1,
        'left-border': idx !== 0
      }])
      }, [
        (idx < _ctx.findedIdx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " check_circle "))
          : (idx === _ctx.findedIdx)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " error "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, "radio_button_unchecked"))
      ], 2))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.judgeStepList, (step) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `disc-${step}`,
        class: "flex justify-center pt-2 pb-2"
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(step), 1)
      ]))
    }), 128))
  ]))
}